export function copy(text) {
    navigator.clipboard.writeText(text);
}
